import { createAsyncThunk } from '@reduxjs/toolkit'

import { getAdditionalHeaders } from '@/network/common/additionalHeaders'
import { internalRequest } from '@/util/request'

import { getCookie } from '../providers/authentication/authentication.helpers'

export const fetchMe = createAsyncThunk('fetch-me', async (_, { rejectWithValue, dispatch }) => {
  const token = getCookie('token')

  try {
    const { data } = await internalRequest({
      headers: { authorization: token, ...(await getAdditionalHeaders()) },
      method: 'GET',
      url: '/me',
      dispatch,
    })

    return data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})
